/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-03-28 11:26:23
 * @modify date 2018-03-28 11:26:23
 * @desc [description]
*/
import { HiverAxios, showMessage } from 'h-commons'
import { 
    DISABLE_CONNECTOR_DONE,
    DISABLE_CONNECTOR_INIT,
    DISABLE_CONNECTOR_FAILED,
    typePrefixMap
} from './';
/**
 * Redux async action used to disable an enabled connector for a shared mailbox
 * @param  {string} type         Connector Type
 * @param  {string|number} smid  Shared Mailbox Id   
 */
export const disableConnector = (type, smid) => dispatch => {
    const successMsg =  'Connector disabled successfully.';
    const failureMsg = 'Failed to disable connector.';
    if (!(type in typePrefixMap)) {
        dispatch({
            type: DISABLE_CONNECTOR_FAILED,
            error: 'Unsupported Connector'
        });
        return;
    }
    dispatch({
        type: DISABLE_CONNECTOR_INIT
    });
    const prefix = typePrefixMap[type];
    const reqtObj ={
        smid:smid
    };
    HiverAxios({
        url: `${prefix}/disable`,
        type: 'POST',
        params: reqtObj,
        callback: resp => {
            if (resp.data && resp.data.success) {              
                dispatch({
                    type: DISABLE_CONNECTOR_DONE,
                    payload: { enabled: false, smid, type }
                });
                showMessage({message:successMsg,type:'success'});
            } else {
                showMessage({message:failureMsg,type:'error'});
                dispatch({
                    type: DISABLE_CONNECTOR_FAILED,
                    error: failureMsg
                });
            }
        },
        onfail: err => {
            dispatch({
                type: DISABLE_CONNECTOR_FAILED,
                error: err
            });
            showMessage({message:failureMsg,type:'error'});
        }
    });
}